import { stringify } from 'query-string';
import { BASE_URL } from 'constants/api';
import actions from './index';

export const ACTIONS = {
  GET: 'STUDENT_COURSES_GET',
  GET_SUCCESS: 'STUDENT_COURSES_GET_SUCCESS',
  GET_FAILURE: 'STUDENT_COURSES_GET_FAILURE',

  PATCH: 'STUDENT_COURSES_PATCH',
  PATCH_SUCCESS: 'STUDENT_COURSES_PATCH_SUCCESS',
  PATCH_FAILURE: 'STUDENT_COURSES_PATCH_FAILURE',
  INVALIDATE_ITEM: 'STUDENT_COURSES_INVALIDATE_ITEM',
};

export const get = actions.get(
  (studentId, query) => `${BASE_URL}/student-courses/${studentId}/?${stringify(query)}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);

export const patch = actions.patch(
  studentId => `${BASE_URL}/student-courses/${studentId}/`,
  {
    PENDING: ACTIONS.PATCH,
    SUCCESS: ACTIONS.PATCH_SUCCESS,
    FAILURE: ACTIONS.PATCH_FAILURE,
  },
);

export const invalidateItem = (id, query) => dispatch => {
  dispatch({
    type: ACTIONS.INVALIDATE_ITEM,
    payload: { id, query },
  });
};
